import { USER_ID_KEY, USER_NAME_KEY } from "@/constants";

/**
 * Get stored user ID from sessionStorage
 */
export function getStoredUserId(): string | null {
  return sessionStorage.getItem(USER_ID_KEY);
}

/**
 * Set user ID in sessionStorage
 */
export function setStoredUserId(userId: string): void {
  sessionStorage.setItem(USER_ID_KEY, userId);
}

/**
 * Get stored user name from sessionStorage
 */
export function getStoredUserName(): string | null {
  return sessionStorage.getItem(USER_NAME_KEY);
}

/**
 * Set user name in sessionStorage
 */
export function setStoredUserName(name: string): void {
  sessionStorage.setItem(USER_NAME_KEY, name);
}
